// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"20ef0972","90":"6a0bad6a","109":"da8d212c","145":"ec3bf0bd","634":"297c2d3e","744":"1ca81a06","761":"fa01dbb9","787":"198a681d","925":"49fe9b67","977":"994c43fa"}[chunkId] + ".chunk.js";
};